<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/">展覽列表</a><span>/</span>
          <em name="Exhibition"></em> <span>/</span>申請參展證明
        </div>
        <div>
          <span class="bold">登入帳號 :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <article>
      <div class="MbDevice">
        <div class="homeLeft">
          <div class="UserAccount ml-1">
            <span class="bold">登入帳號 :</span>
            <span> {{ UserId }}</span>
          </div>
          <hr />
          <div class="expoLogo"><img :src="ExhLogo" width="100%" /></div>
          <div class="expoInfo">
            <p class="bold" name="Exhibition"></p>
            <p>{{ ExhBegin }} - {{ ExhEnd }}</p>
            <p>{{ ExhVenue }}</p>
          </div>
          <p class="clear"></p>
        </div>
      </div>
      <div class="contentBox">
        <h1>申請參展證明</h1>
        <p class="py-3">&nbsp;</p>

        <div>
          感謝貴司對本屆展覽的支持。若您需要申請「參展證明」，請點選下方下載鍵：
        </div>

        <div
          class="btn btn-lg btn-primary text-nowrap mt-3 mb-4"
          @click.prevent="downloadCertification"
        >
          點此下載參展證明
        </div>

        <div>
          *證明書上的公司名稱及相關資訊，將<span class="bold"
            >直接採用您當初提交之「報名表」資料</span
          >為主。
        </div>
        <div>
          *若文件內容有誤或需調整，歡迎來信聯繫：
          <span v-if="Hanoi">
            <a
              href="mailto:Overseas_Machinery@chanchao.com.tw"
              style="text-decoration: none; color: inherit"
            >
              Overseas_Machinery@chanchao.com.tw
            </a>
          </span>
          <span v-else
            ><a
              href="mailto:op@chanchao.com.tw"
              style="text-decoration: none; color: inherit"
            >
              op@chanchao.com.tw
            </a></span
          >
        </div>

        <p class="clear"></p>
      </div>
    </article>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  components: {},

  metaInfo() {
    return {
      title: "申請參展證明 - 展昭參展商管理系統",
    };
  },

  data() {
    return {
      UserId: "",
      RegNo2: "",

      ExhLogo: "",
      ExhBegin: "",
      ExhEnd: "",
      ExhVenue: "",
      eExhVenue: "",
      Hanoi: false,
    };
  },

  methods: {
    downloadCertification() {
      let vm = this;

      axios
        .get(
          `https://www.chanchao.com.tw/apiExhibitors/Certification/DownloadPDF/${vm.RegNo2}`,
          {
            responseType: "blob",
          },
        )
        .then(function (response) {
          // 判斷是否為 JSON (代表失敗)
          if (response.data.type === "application/json") {
            const reader = new FileReader();
            reader.onload = function () {
              const errorData = JSON.parse(reader.result);
              alert(errorData.Message || "Download Failed");
            };
            reader.readAsText(response.data);
          } else {
            // 成功：建立隱藏連結
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;

            // --- 這裡修改為你指定的固定名稱 ---
            link.setAttribute("download", "Stand Assignment Certificate.pdf");

            document.body.appendChild(link);
            link.click();

            // 清理
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          }
        })
        .catch(function (error) {
          console.log(error);
          alert("System busy, please try again later.");
        });
    },
  },

  created() {
    const vm = this;

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //url取出展碼
    let nowPage = location.href;
    let RegNo = nowPage.split("no=")[1];

    vm.RegNo2 = RegNo;

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${RegNo}?lang=tw`,
      )
      .then((response) => {
        vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`;
        vm.ExhBegin = response.data.Data.ExhBegin;
        vm.ExhEnd = response.data.Data.ExhEnd;
        vm.ExhVenue = response.data.Data.ExhVenue;
        vm.eExhVenue = response.data.Data.eExhVenue;
        let ExhCode = response.data.Data.Original_Code;
        if (
          ExhCode == "HNPlas" ||
          ExhCode == "HNPrintPack" ||
          ExhCode == "FAUIVN"
        ) {
          vm.Hanoi = true;
        } else {
          vm.Hanoi = false;
        }
      });
  },
};
</script>

<style lang="scss">
@import "./../../assets/helper/table.css";
@import "./../../assets/helper/fancybox.css";
</style>
